import { Card, ChoiceList, FormLayout, Layout, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import HeadingHelper from "../../helpers/HeadingHelper";
import Switch from "react-switch/index";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import React from "react";

const CompanyMarketplaces = (props) => {
  const {
    marketplaceActive, marketplaces, marketplaceOthers,
    handleChange, handleChoiceListChange,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("company.annotate.title.marketplaces")}
      description={CsI18n.t("company.annotate.desc.marketplaces")}>
      <Card>
        <Card.Section>
          <FormLayout>
            {HeadingHelper.h3tt('I sell on marketplaces', 'company.explain.marketplaces')}
            <Switch
              className="react-switch"
              onChange={handleChange('marketplaceActive')}
              checked={marketplaceActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("I sell on marketplaces")}
            />
            {marketplaceActive &&
            <FormLayout.Group>
              <div className="ChoiceList-Multiple">
                <ChoiceList
                  allowMultiple
                  title={<CsI18n>National</CsI18n>}
                  choices={ChoiceHelper.choices(marketplaces)}
                  selected={ChoiceHelper.selected(marketplaces)}
                  onChange={handleChoiceListChange("marketplaces")}
                />
              </div>
              <TextField
                label={CsI18n.t("Other marketplaces")}
                onChange={handleChange("marketplaceOthers")}
                value={marketplaceOthers}
                placeholder={CsI18n.t("Ex: Darty, Galeries, Lagayette")}
                multiline
              />
            </FormLayout.Group>}
          </FormLayout>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  )
};

export default CompanyMarketplaces;